import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TemplatesService } from './templates.service';

@Component({
    selector: 'app-delete-template',
    templateUrl: './app-delete-template.html',
    styleUrls: ['./templates.component.css']
})
export class DeleteTemplateModal implements OnInit {

    constructor(
        public dialog: MatDialog,
        private _service: TemplatesService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private toastr: ToastrService,
        public dialogRef: MatDialogRef<DeleteTemplateModal>

    ) { }
    templates: any
    templatesArray: any = []



    ngOnInit() {
    }
    deleteTemplate() {
        if (this.data.type == 'Bulk') {

            if (this.data.values[0].id) {
                let item = {
                    id: this.data.values[0].id,
                    sharepointId: this.data.values[0].sharepointId,
                }
                this.templatesArray[0] = item
                this.templates = this.templatesArray


            }
            else {
                this.templates = this.data.values[0].map(item => {

                    return {
                        id: item.id,
                        sharepointId: item.sharepointId,


                    };

                });

            }


            this._service.DeleteTemplatesInBulk(this.templates).subscribe(x => {
                this.closeDialog(true);

            })
        }
        else {
            this._service.DeleteTemplateById(this.data.values[0]).subscribe(x => {
                this.closeDialog(true);
            })
        }
    }
    closeDialog(status) {
        this.dialogRef.close(status);
    }
}
